import { useState } from "react";
import { Head, Link } from "@inertiajs/react";
import { UserPlus, Upload } from "lucide-react";
import SchoolLayout from "@/components/schools/SchoolLayout";
import { Button } from "@/components/ui/button";
import MembersTable, { InviteMemberForm } from "@/components/schools/MembersTable";

export default function Members({ school, membership, members, create_path, import_teachers_path, roles, invite_roles, invites_held }) {
  const [inviting, setInviting] = useState(false);

  return (
    <SchoolLayout
      school={school}
      membership={membership}
      title="Members"
      actions={
        <>
          {import_teachers_path && (
            <Button size="sm" variant="outline" asChild>
              <Link href={import_teachers_path}>
                <Upload className="h-4 w-4" />
                Invite teachers from a spreadsheet
              </Link>
            </Button>
          )}
          {!inviting && (
            <Button size="sm" onClick={() => setInviting(true)}>
              <UserPlus className="h-4 w-4" />
              Invite someone
            </Button>
          )}
        </>
      }
    >
      <Head title="Members" />

      <div className="space-y-6">
        {inviting && (
          <InviteMemberForm
            createPath={create_path}
            roles={invite_roles}
            invitesHeld={invites_held}
            initialRole={invite_roles.includes("teacher") ? "teacher" : invite_roles[0]}
            onCancel={() => setInviting(false)}
          />
        )}

        <MembersTable members={members} roles={roles} />
      </div>
    </SchoolLayout>
  );
}
